var _path, _path2, _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-mv",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007e3a",
    d: "M128 128h256v256H128z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 256,
    r: 85.3,
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.6,
    cy: 256,
    fill: "#007e3a",
    rx: 73.9,
    ry: 85.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.8cb05cc8693221f2eec147eb4f657c4f.svg";
export { ForwardRef as ReactComponent };